import { mdiAlert, mdiAlertCircle, mdiCheckCircle } from '@mdi/js';
import { computed, ComputedRef, Ref } from '@vue/composition-api';
import { keyEnumObject, ValueTypeOf } from '@berlin-front/common/utils';

/**
 * アラート種別の情報。
 */
export const ALERT_MAP = {
  error: { icon: mdiAlertCircle },
  warning: { icon: mdiAlert },
  success: { icon: mdiCheckCircle },
} as const;

/**
 * アラート種別定数。
 */
export const ALERT_TYPE = keyEnumObject(ALERT_MAP);

/**
 * アラート種別の型。
 */
export type AlertType = ValueTypeOf<typeof ALERT_TYPE>;

/**
 * アイコンを使用する。
 */
export const useAlertIcon = (alertType: Ref<AlertType>): ComputedRef<string> =>
  computed(() => ALERT_MAP[alertType.value].icon);
